import type {
  RouteDefinition,
  SubscriptionFlowPagesKeys,
} from '../types/routes'
import type { Funnel } from '../types/state'

export const ONBOARDING_PATH = 'onboarding'

export const getSubscriptionFlowPages = (
  funnelId: Funnel | typeof ONBOARDING_PATH
) => {
  return {
    subscription: {
      path: `/${funnelId}/subscription`,
      id: 'subscription',
    },
    paymentProcessed: {
      path: `/${funnelId}/payment-processed`,
      id: 'payment_processed',
    },
    password: {
      path: `/${funnelId}/password`,
      id: 'password',
    },
    exclusiveOffer: {
      path: `/${funnelId}/exclusive-offer`,
      id: 'add_on',
      isExcludedFromProgressBarOrStepper: true,
    },
    success: {
      path: `/${funnelId}/success`,
      id: 'success',
    },
  } satisfies Record<SubscriptionFlowPagesKeys, RouteDefinition>
}

export const getRequiredFunnelPages = (
  funnelId: Funnel | typeof ONBOARDING_PATH
) => {
  return {
    email: {
      path: `/${funnelId}/email`,
      id: 'email',
    },
    ...getSubscriptionFlowPages(funnelId),
  }
}
